

export const productData = [
  {
    id: 1,
    name: "product1",
    apiLink: "apiLink1",
    siteLink: "siteLink1",
    version: "version1",
    created: "Ravi",
    subscription: [],
  },
  {
    id: 2,
    name: "product2",
    apiLink: "apiLink2",
    siteLink: "siteLink2",
    version: "version2",
    created: "Ram",
    subscription: [],
  },
  {
    id: 3,
    name: "product3",
    apiLink: "apiLink3",
    siteLink: "siteLink3",
    version: "version3",
    created: "Narmu",
    subscription: [],
  },
];
